const initialState = {
    getdetails1:[],
    getdetails2:[],
   
    
    
  
  };
  
  const DOViewDoctorReducers = (state = initialState, action: any) => {
    switch (action.type) {
            case 'FETCH_GET1_SUCCESS':
            return {... state, getdetails1:action.payload};
            case 'FETCH_GET2_SUCCESS':
            return {... state, getdetails2:action.payload};
            
            

      default:
        return state;
    }
  };
  
  export default DOViewDoctorReducers;
  
  